module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/join-bg-75690be7ab7f47053f8cf1ffac6b3321.jpg";